import React from 'react'


const FooterUser = () => {

      {/* --------------footer css------------------ */}
  
  const footerStyle = {
    backgroundColor:"orangered",
    boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
    padding:"8px",
    textAlign:"center",
    color:"#000",
    fontSize:"12px",
    position:"fixed",
    bottom:0,
    width:"100%",
    letterSpacing:"1px",
  }

  return (
    <div className='row m-0' style={footerStyle}>
        <span>MANIKBAG DIGAMBAR JAIN BOARDING | Managed By : TechnoAarv Solution</span>
    </div>
  )
}

export default FooterUser